import React from 'react'
import createClass from 'create-react-class'
import PropTypes from 'prop-types'
import { Input, FormFeedback } from 'reactstrap'

const RangeInputInfinity = createClass({
  propTypes: {
    value: PropTypes.array,
    valueChangeFunction: PropTypes.func.isRequired,
    uniqId: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    invalid: PropTypes.string
  },

  parseValue(value) {

    if (typeof value === 'string') {
      const normalized = value.toLowerCase();
      if (normalized === 'infinity' || normalized === '∞') {
        return Infinity;
      }
    }
    return value;
  },

  formatValue(value) {
    return value === Infinity ? '∞' : value;
  },

  onLowerBoundChange(e) {
    this.props.valueChangeFunction([
      this.parseValue(e.target.value),
      this.maxValue()
    ]);
  },

  onUpperBoundChange(e) {
    this.props.valueChangeFunction([
      this.minValue(),
      this.parseValue(e.target.value)
    ]);
  },

  handleOnChange(value) {
    this.props.valueChangeFunction(value);
  },

  minValue() {
    return this.props.value ? this.props.value[0] : 0;
  },

  maxValue() {
    return this.props.value ? this.props.value[1] : 0;
  },

  render() {
    return [
      <td key={`range_begin_${this.props.uniqId}`}>
        <Input
          className={this.props.invalid ? 'is-invalid' : ''}
          name={`range_begin_${this.props.uniqId}`}
          type="text"
          disabled={this.props.disabled}
          max={this.maxValue()}
          value={this.formatValue(this.minValue())}
          onChange={this.onLowerBoundChange}
        />
      </td>,
      <td key={`range_end_${this.props.uniqId}`}>
        <Input
          className={this.props.invalid ? 'is-invalid' : ''}
          name={`range_end_${this.props.uniqId}`}
          type="text"
          disabled={this.props.disabled}
          min={this.minValue()}
          value={this.formatValue(this.maxValue())}
          onChange={this.onUpperBoundChange}
        />
        <FormFeedback>{this.props.invalid}</FormFeedback>
      </td>
    ];
  }
});

export default RangeInputInfinity



// WEBPACK FOOTER //
// ./src/components/Wps/helpers/RangeInputInfinity.js